<template>
  <div v-for="(name, index) in outOfStockNoveltyNames" :key="index" :class="$style.novelty_end_text">
    {{ name }} は終了いたしました。
  </div>
</template>

<script setup lang="ts">
import type { NoveltyFront } from "@tential/ec-gql-schema/models/novelty"
import { useNovelty } from "~/composables/useNovelty"

const { getNoveltiesForProduct } = useNovelty()

type Product = { document_id: string; novelty_start_unixtime?: number; novelty_end_unixtime?: number }
type Props = {
  product: Product | Product[]
}

const props = withDefaults(defineProps<Props>(), {})
// 商品のノベルティキャンペーン一覧
const novelties: NoveltyFront[] = await getNoveltiesForProduct(props.product)

const noveltyNames: string[] = []
novelties.forEach((novelty) => {
  const names = novelty.novelty_patterns
    .filter((pattern) => !pattern.is_novelty_stock)
    .map((pattern) => pattern.public_name)
  if (names.length > 0) {
    noveltyNames.push(...names)
  }
})
// ノベルティの在庫が切れているキャンペーン一覧（同じ名前のキャンペーン名は一つにまとめる）
const outOfStockNoveltyNames = [...new Set(noveltyNames)]
</script>

<style scoped lang="scss" module>
.novelty_end_text {
  font-size: $font-size-12;
  color: #ff0000;
  text-align: center;
  font-weight: bold;
}
</style>
